/**
 * ALL CUSTOM CODE SHALL BE MADE IN THIS FILE AND NOT IN
 * THE ORIGINAL THEME FILES.
 *
 * Changelog:
 * 1.  22.10.2018 / enzo@exportarts.io / Cart Checkout + Delivery Date
 * 2.  23.10.2018 / enzo@exportarts.io / Added dedicated inputs for date, time and zip
 * 3.  30.10.2018 / enzo@exportarts.io / Added zip-check modal
 * 4.  31.10.2018 / enzo@exportarts.io / Removed old logic for custom delivery time and zip inputs
 * 5.  01.11.2018 / enzo@exportarts.io / Refactored
 * 6.  01.11.2018 / enzo@exportarts.io / Added Zip.watchAddToCartButton()
 * 7.  05.11.2018 / enzo@exportarts.io / Added "Check Now" Button in Top-Bar
 * 8.  02.11.2018 / enzo@exportarts.io / Setting submit button disabled instaed of hiding it
 * 9.  11.10.2019 / enzo@exportarts.io / Better validation of submit button to avoid invalid dates being passed
 * 10. 12.03.2020 / tim@exportarts.io / Implement order valuer check for food related products
 *
 */

/* -----------
 * Define our custom namespace
 * -----------
 */
window.Exportarts = {};

/* -----------
 * Custom ZIP availability checks
 * -----------
 */
window.Exportarts.Zip = {};

/* -----------
 * Utilities
 * -----------
 */
window.Exportarts.Util = {
  /**
   * Modifies the date in place.
   *
   * @param {Date} date 
   */
  addDay: (date) => {
    const time = date.getTime();
    const day = 86400000;
    date.setTime(time + day);
  },
  /**
   * @param {Date} date 
   * @returns YYYY-MM-DD
   */
  getSqlDate: (date) => {
    return date.getFullYear()
      + '-'
      + ((date.getMonth() + 1) + '').padStart(2, '0')
      + '-'
      + (date.getDate() + '').padStart(2, '0')
  }
};

/**
 * onShow-Config for the modal
 */
window.Exportarts.Zip.ModalConfig = function() {
  return {
    onShow: function(modal) {
      // Reset the modal-internal fields and states
      var input = $('#js-modal-zip-input');
      var hint = $('#js-modal-zip-hint');
      var submit = $('#js-modal-submit-button');
      var postpone = $('#js-modal-postpone-button');
      var continueButton = $('#js-modal-continue-button');
      var closeButton = $('#js-modal-close-button');
      var successMessage = $('#js-modal-success');
      var failMessage = $('#js-modal-fail');
      var descriptionText = $('#js-modal-description');
      
      input.css('display', 'block');
      hint.css('display', 'none');
      submit.css('display', 'block');
      postpone.css('display', 'block');
      continueButton.css('display', 'none');
      closeButton.css('display', 'none');
      successMessage.css('display', 'none');
      failMessage.css('display', 'none');
      descriptionText.css('display', 'block');
    },
    onClose: function() {
      window.Exportarts.Cart.enforceRequiredFields();
    }
  };
}

/**
 * Initialize MicroModal
 */
window.Exportarts.Zip.initModal = function() {
  MicroModal.init();
}

/**
 * Keys for SessionStorage
 */
window.Exportarts.Zip.KEYS = function() {
  return {
    ZIP: 'EXPO_MUTTI_ZIP',
    ZIP_VALID: 'EXPO_MUTTI_ZIP_VALID',
    POSTPONED: 'EXPO_MUTTI_ZIP_DIALOG_POSTPONED'
  };
}

/**
 * Check if the provided ZIP is valid
 * based on the list of allowed ZIPs.
 *
 * @return boolean
 */
window.Exportarts.Zip.isValidZip = function () {
  return window.Exportarts.Zip.allowedZips().includes(sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP));
}

/**
 * This function is responsible for maintaining
 * the status of the ZIP-status announcement in the
 * top bar (header.liquid).
 */
window.Exportarts.Zip.updateTopBar = function() {
  var topBar = $('#js-topbar-zip');
  var topBarPending = $('#js-topbar-zip-pending');
  var topBarSuccess = $('#js-topbar-zip-success');
  var topBarFail = $('#js-topbar-zip-fail');
  var checkNowButton = $('#js-topbar-check-now-button');
  var notYetChecked = sessionStorage.getItem(window.Exportarts.Zip.KEYS().POSTPONED) === 'true' || sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP) === null;
  var success = sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP_VALID) === 'true';
  
  if (success && !notYetChecked) {
    topBarPending.css('display', 'none');
    topBarFail.css('display', 'none');
    topBarSuccess.css('display', 'block');
    topBar.css('background', '#446c44');
    checkNowButton.css('display', 'none');
  } else if (!success && !notYetChecked) {
    topBarPending.css('display', 'none');
    topBarSuccess.css('display', 'none');
    topBarFail.css('display', 'block');
    topBar.css('background', '#8d3939');
    checkNowButton.css('display', 'block');
  }
}

/**
 * Apply handler to the "Check now"-button
 */
window.Exportarts.Zip.addTopBarHandler = function() {
  var checkNowButton = $('#js-topbar-check-now-button');

  checkNowButton.click(function() {
    MicroModal.show('js-zip-modal', window.Exportarts.Zip.ModalConfig());
  });
}

/**
 * Use this method to check if the script is currently executed on a product-detail page.
 */
window.Exportarts.Zip.isProductPage = function() {
  return window.location.pathname.indexOf('/products/') > 0;
}

/**
 * This function reacts to inputs in the ZIP-modal
 * and changes the UI based on the results.
 */
window.Exportarts.Zip.watch = function() {
  if (window.Exportarts.Zip.isProductPage() && (sessionStorage.getItem(window.Exportarts.Zip.KEYS().POSTPONED) === 'true' || sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP) === null)) {
	MicroModal.show('js-zip-modal', window.Exportarts.Zip.ModalConfig());
  }
  var input = $('#js-modal-zip-input');
  var hint = $('#js-modal-zip-hint');
  var submit = $('#js-modal-submit-button');
  var postpone = $('#js-modal-postpone-button');
  var continueButton = $('#js-modal-continue-button');
  var closeButton = $('#js-modal-close-button');
  var successMessage = $('#js-modal-success');
  var failMessage = $('#js-modal-fail');
  var descriptionText = $('#js-modal-description');
  
  var addToCartButton = $('#js-product-add-to-cart-button');
  var checkZipButton = $('#js-product-check-zip-button');
  var unavailableInfo = $('#js-product-unavailable-info');
  var quantitySelect = $('#js-product-quantity-select');
  
  var checkNowButton = $('#js-topbar-check-now-button');
  
  input.on('input', function() {
    sessionStorage.setItem(window.Exportarts.Zip.KEYS().ZIP, input.val());
    var isValidZip = /^[0-9]{5}$/.test(sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP));
    
    if (!isValidZip) {
      hint.css('display', 'block');
      submit.prop('disabled', true);
    } else {
      hint.css('display', 'none');
      submit.prop('disabled', false);
    }
  });
  submit.click(function() {
    if (submit.prop('disabled') === false) {
      if (window.Exportarts.Zip.isValidZip()) {
    	sessionStorage.setItem(window.Exportarts.Zip.KEYS().ZIP_VALID, true);
    	sessionStorage.setItem(window.Exportarts.Zip.KEYS().POSTPONED, false);
        addToCartButton.css('display', 'block');
        checkZipButton.css('display', 'none');
        successMessage.css('display', 'block');
        failMessage.css('display', 'none');
        submit.css('display', 'none');
        postpone.css('display', 'none');
        continueButton.css('display', 'block');
        input.css('display', 'none');
        descriptionText.css('display', 'none');
    	checkNowButton.css('display', 'none');
      } else {
    	sessionStorage.setItem(window.Exportarts.Zip.KEYS().ZIP_VALID, false);
    	sessionStorage.setItem(window.Exportarts.Zip.KEYS().POSTPONED, false);
        submit.css('display', 'none');
        postpone.css('display', 'none');
        descriptionText.css('display', 'none');
        successMessage.css('display', 'none');
        failMessage.css('display', 'block');
        closeButton.css('display', 'block')
        addToCartButton.css('display', 'none');
        checkZipButton.css('display', 'none');
    	unavailableInfo.css('display', 'block');
    	quantitySelect.css('display', 'none');
	    checkNowButton.css('display', 'block');
      }
      
      window.Exportarts.Zip.updateTopBar();
    }
  });
  postpone.click(function () {
    sessionStorage.setItem(window.Exportarts.Zip.KEYS().POSTPONED, true);
  })
}

/**
 * This function prevents items from beeing added to the cart
 * without having entered a valid ZIP
 */
window.Exportarts.Zip.watchAddToCartButton = function() {
  var addToCartButton = $('#js-product-add-to-cart-button');
  var checkZipButton = $('#js-product-check-zip-button');
  var unavailableInfo = $('#js-product-unavailable-info');
  var quantitySelect = $('#js-product-quantity-select');
  if (window.Exportarts.Zip.isProductPage() && sessionStorage.getItem(window.Exportarts.Zip.KEYS().POSTPONED) === 'true' || sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP) === null) {
    addToCartButton.css('display', 'none');
    checkZipButton.css('display', 'block');
    checkZipButton.click(function(event) {
      event.preventDefault();
      event.stopPropagation();
      MicroModal.show('js-zip-modal', window.Exportarts.Zip.ModalConfig());
    })
  } else if (sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP_VALID) === 'false') {
    addToCartButton.css('display', 'none');
    quantitySelect.css('display', 'none');
    unavailableInfo.css('display', 'block');
  }
}

/**
 * This method appends the stored ZIP to the cart URL to prefill
 * the field during checkout.
 */
window.Exportarts.Zip.prefillCartAction = function() {
  if (window.location.pathname === '/cart') {
    var zip = sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP);
    if (zip && sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP_VALID) === 'true') {
      var form = $('#js-cart-form');
      form.prop('action', '/cart?checkout[shipping_address][zip]=' + zip);
    }
  }
}

window.Exportarts.Cart = {};

/**
 * Configuration for delivery time validation
 */
window.Exportarts.DeliveryValidation = {
  earliestHour: 8,
  earliestMinute: 0,
  latestHour: 18,
  latestMinute: 30,
  minimumOrderValue: 15000,
  minimumWorkDaysBeforeDelivery: 3,
  /**
   * These product ids will not be included in the total price calculation
   * for checking the minimum order value.
   */
  excludeProductIdsFromOrderValue: [
    6570765680691
  ],
  blockedDeliveryDates: [
    '2021-07-16',
    '2021-08-08',
    '2021-09-02',
    '2021-09-03',
    '2021-09-04',
    '2021-09-07',
    '2021-09-08',
    '2021-09-09',
    '2021-09-11',
    '2021-09-30',
    '2021-10-01',
    '2021-10-02',
    '2021-10-03',
    '2021-10-04',
    '2021-10-05',
    '2021-10-06',
    '2021-10-07',
    '2021-10-08',
    '2021-10-09',
    '2021-10-10',
    '2021-10-11',
    '2021-10-12',
    '2021-10-13',
    '2021-10-14',
    '2021-10-15',
    '2021-10-16',
    '2021-10-17',
    '2021-12-25',
    '2021-12-26',
    '2021-12-27',
    '2021-12-28',
    '2021-12-29',
    '2021-12-30',
    '2021-12-31',
    '2022-01-01',
    '2022-01-02',
    '2022-01-03',
    '2022-03-22',
    '2022-03-23',
    '2022-03-24',
    '2022-03-25',
    '2022-03-26',
    '2022-03-20',
    '2022-03-27',
    '2022-03-31',
    '2022-04-01',
    '2022-04-02',
    '2022-04-03',
    '2022-04-08',
    '2022-04-09',
    '2022-04-10',
    '2022-04-16',
    '2022-04-17',
    '2022-04-23',
    '2022-04-24',
    '2022-04-30',
    '2022-05-01',
    '2022-05-08',
    '2022-05-15',
    '2022-05-16',
    '2022-05-17',
    '2022-05-18',
    '2022-05-19',
    '2022-05-20',
    '2022-05-21',
    '2022-05-22',
    '2022-05-23',
    '2022-05-24',
    '2022-05-25',
    '2022-05-26',
    '2022-05-27',
    '2022-05-28',
    '2022-05-29',
    '2022-06-01',
    '2022-06-02',
    '2022-06-05',
    '2022-06-11',
    '2022-06-12',
    '2022-06-15',
    '2022-06-17',
    '2022-06-18',
    '2022-06-19',
    '2022-06-20',
    '2022-06-21',
    '2022-06-22',
    '2022-06-23',
    '2022-06-24',
    '2022-06-25',
    '2022-06-26',
    '2022-07-02',
    '2022-07-03',
    '2022-07-04',
    '2022-07-05',
    '2022-07-06',
    '2022-07-07',
    '2022-07-08',
    '2022-07-09',
    '2022-07-10',
    '2022-07-11',
    '2022-07-12',
    '2022-07-13',
    '2022-07-14',
    '2022-07-15',
    '2022-07-16',
    '2022-07-17',
    '2022-07-18',
    '2022-07-19',
    '2022-07-20',
    '2022-07-21',
    '2022-07-22',
    '2022-07-23',
    '2022-07-24',
    '2022-07-31',
    '2022-08-06',
    '2022-08-07',
    '2022-08-13',
    '2022-08-14',
    '2022-08-21',
    '2022-08-22',
    '2022-08-23',
    '2022-08-24',
    '2022-08-25',
    '2022-08-26',
    '2022-08-27',
    '2022-08-28',
    '2022-08-29',
    '2022-08-30',
    '2022-08-31',
    '2022-09-01',
    '2022-09-02',
    '2022-09-03',
    '2022-09-04',
    '2022-09-05',
    '2022-09-06',
    '2022-09-07',
    '2022-09-08',
    '2022-09-09',
    '2022-09-10',
    '2022-09-11',
    '2022-09-18',
    '2022-09-25',
    '2022-10-02',
    '2022-10-09',
    '2022-10-16',
    '2022-10-23',
    '2022-10-30',
    '2022-11-06',
    '2022-11-13',
    '2022-11-20',
    '2022-11-27',
    '2022-12-04',
    '2022-12-11',
    '2022-12-18',
    '2022-12-25',
    
  ],
  /**
   * If one of these products is in the cart, the section for selecting the
   * pickup date/time are presented.
   */
  pickupProductIds: [
    6570765680691
  ]
};

/**
 * This function makes sure that the required fields for an order are set:
 * - Delivery Date
 * - Delivery Time
 * - ZIP
 * - Minimum Order Value
 */
window.Exportarts.Cart.enforceRequiredFields = function() {
  if (window.location.pathname === '/cart') { 
    var valueHint = $('#js-cart-minimum-value-hint');
    var checkOutButton = $('#js-checkout-submit-button');
    var zipHint = $('#js-cart-zip-hint');
    var checkZipLink = $('#js-cart-check-zip-link');
    checkZipLink.click(function() {
      MicroModal.show('js-zip-modal', window.Exportarts.Zip.ModalConfig());
    });
    var deliveryDateInput = $('#js-cart-delivery-date-input');
    var deliveryDateHintInvalid = $('#js-cart-delivery-date-is-invalid');
    var deliveryDateHintPast = $('#js-cart-delivery-date-is-past');
    var deliveryDateHintTooEarly = $('#js-cart-delivery-date-is-too-early');
    var deliveryDateHintSunday = $('#js-cart-delivery-date-no-sunday');
    var deliveryDateHintBlocked = $('#js-cart-delivery-date-is-blocked');
    var deliveryTimeInput = $('#js-cart-delivery-time-input');
    var deliveryTimeInvalid = $('#js-cart-delivery-time-is-invalid');
    var deliveryTimeRequired = $('#js-cart-delivery-time-is-required');
    const pickupSection = $('#js-pickup-section');
    const pickupDateInput = $('#js-cart-pickup-date-input');
    
    var performCheck = function(triggeredFromPickupInput) {
      checkOutButton.prop("disabled", true);
      deliveryDateHintInvalid.css('display', 'none');
      deliveryDateHintPast.css('display', 'none');
      deliveryDateHintTooEarly.css('display', 'none');
      deliveryDateHintSunday.css('display', 'none');
      deliveryDateHintBlocked.css('display', 'none');
      deliveryTimeInvalid.css('display', 'none');
      deliveryTimeRequired.css('display', 'none');

      if (!triggeredFromPickupInput) {
        valueHint.css('display', 'none');
        zipHint.css('display', 'none');
        pickupSection.css('display', 'none');
      }
      
      var zip = sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP);
      var zipValid = sessionStorage.getItem(window.Exportarts.Zip.KEYS().ZIP_VALID) === 'true';
      const deliveryDateString = deliveryDateInput.val();
      var deliveryDate = new Date(deliveryDateString);

      if (!deliveryDate || isNaN(deliveryDate.getTime())) {
        deliveryDateHintInvalid.css('display', 'block');
        return;
      }
      
      if (window.Exportarts.DeliveryValidation.blockedDeliveryDates.includes(deliveryDateString)) {
        deliveryDateHintBlocked.css('display', 'block');
        return;
      }

      const now = new Date();
      now.setHours(0, 0, 0, 0);
      deliveryDate.setHours(0, 0, 0, 0);

      if (deliveryDate.getTime() < now.getTime()) {
        deliveryDateHintPast.css('display', 'block');
        return;
      }

      const targetWeekDay = deliveryDate.getDay();
      
      if (targetWeekDay === 0) {
        deliveryDateHintSunday.css('display', 'block');
        return;
      }

      const diffDays = (deliveryDate.getTime() - now.getTime()) / (24 * 60 * 60 * 1000);
      if (diffDays < window.Exportarts.DeliveryValidation.minimumWorkDaysBeforeDelivery) {
        deliveryDateHintTooEarly.css('display', 'block');
        return;
      }
      
      // A string like "HH:MM"
      const deliveryTime = deliveryTimeInput.val();
      if (deliveryTime.length === 5) {
        const [ deliveryHours, deliveryMinutes ] = deliveryTime.split(':').map(part => parseInt(part));
        const minutes = 60 * deliveryHours + deliveryMinutes;
        const minMinutes = 60 * window.Exportarts.DeliveryValidation.earliestHour + window.Exportarts.DeliveryValidation.earliestMinute;
        const maxMinutes = 60 * window.Exportarts.DeliveryValidation.latestHour + window.Exportarts.DeliveryValidation.latestMinute;
        if (minutes < minMinutes || minutes > maxMinutes) {
          deliveryTimeInvalid.css('display', 'block');
          return;
        }
      } else {
        deliveryTimeRequired.css('display', 'block');
        return;
      }
      
      // Get cart items and check final price for food products
      let orderValue = 0;
      jQuery.getJSON('/cart.js', function(cart) {
        let pickupRequired = false;
        for (const item of cart.items) {
          if (window.Exportarts.DeliveryValidation.pickupProductIds.includes(item.product_id)) {
            pickupRequired = true;
          }
          if (window.Exportarts.DeliveryValidation.excludeProductIdsFromOrderValue.includes(item.product_id)) {
            continue;
          }
          orderValue += item.final_line_price;
        }

        if (pickupRequired || triggeredFromPickupInput) {
          pickupSection.css('display', 'block');
          window.Exportarts.Cart.validatePickupSection(deliveryDate);
        }

        if (orderValue < window.Exportarts.DeliveryValidation.minimumOrderValue) {
          valueHint.css('display', 'block');
          return;
        } else if (!zip || !zipValid) {
          valueHint.css('display', 'none');
          zipHint.css('display', 'block');
          return;
        } else {
          zipHint.css('display', 'none');
          checkOutButton.prop("disabled", false);
        }
      });   
    }
    
    $("body").on('DOMSubtreeModified', "#js-cart-total", function() { performCheck(); });
    $("body").on('DOMSubtreeModified', "#js-topbar-zip", function() { performCheck(); });
    deliveryDateInput.change(function() { performCheck(); });
    deliveryTimeInput.change(function() { performCheck(); });
    pickupDateInput.change(function() { performCheck(true); });
    setTimeout(function() { performCheck(); }, 1);
  } 
}

window.Exportarts.Cart.validatePickupSection = function (deliveryDate) {
  const tooEarlyHint = $('#js-cart-pickup-date-too-early');
  tooEarlyHint.css('display', 'none');

  const pickupDateInput = $('#js-cart-pickup-date-input');
  const pickupDate = new Date(deliveryDate);

  do {
    window.Exportarts.Util.addDay(pickupDate);
  } while ([0, 6].includes(pickupDate.getDay()))

  const dateString = window.Exportarts.Util.getSqlDate(pickupDate);

  pickupDateInput.val(dateString);
  pickupDateInput.prop('disabled', true);

  if (pickupDate.getTime() <= deliveryDate.getTime()) {
    tooEarlyHint.css('display', 'block');
    return;
  }
}

window.Exportarts.Cart.initDeliveryTimeValidation = function() {
  const deliveryTimeInput = $('#js-cart-delivery-time-input');
  const earliestHour = (window.Exportarts.DeliveryValidation.earliestHour + '').padStart(2, '0');
  const earliestMinute = (window.Exportarts.DeliveryValidation.earliestMinute + '').padStart(2, '0');
  const latestHour = (window.Exportarts.DeliveryValidation.latestHour + '').padStart(2, '0');
  const latestMinute = (window.Exportarts.DeliveryValidation.latestMinute + '').padStart(2, '0');
  deliveryTimeInput.attr('min', earliestHour + ':' + earliestMinute);
  deliveryTimeInput.attr('max', latestHour + ':' + latestMinute);
  $('#js-cart-delivery-time-earliest-hour').html(earliestHour);
  $('#js-cart-delivery-time-earliest-minute').html(earliestMinute);
  $('#js-cart-delivery-time-latest-hour').html(latestHour);
  $('#js-cart-delivery-time-latest-minute').html(latestMinute);
}

/* -----------
 * Entry point
 * -----------
 */
$(document).ready(function() {
  window.Exportarts.Cart.initDeliveryTimeValidation();

  window.Exportarts.Zip.initModal();
  window.Exportarts.Zip.watch();
  window.Exportarts.Zip.updateTopBar();
  window.Exportarts.Zip.addTopBarHandler();
  window.Exportarts.Zip.watchAddToCartButton();
  window.Exportarts.Zip.prefillCartAction();
  
  window.Exportarts.Cart.enforceRequiredFields();
});
